export const defaultEmailElement = {
  /*   eventId: 0, */
 /*    confirmationId: null,
    communicationId: null, */
    languageCode: "",
    id: -1,
    sortOrder: 0,
    style: null,
    families: [],
    content: null,
    settings: null,
    startTag: '',
    endTag: '',
    type: null,
  }